import React from 'react'
import {styledComponent} from '/app/src/higherOrderComponent'

class Div extends React.Component
{
    constructor(props){
        super(props)
        this.onClick = this.onClick.bind(this)
    }
    onClick(e){
        if(this.props.onClick) this.props.onClick(e)
    }

    render()
    {
        return (
            <div className={this.props.className}>
                {this.props.children}
            </div>
        );
    }
}

const StyledDiv =  styledComponent(Div)

StyledDiv.defaultProps = {
    defaultStyle: {
    }
}

export default StyledDiv



// WEBPACK FOOTER //
// src/component/Div/index.js